import { Component, Input } from '@angular/core';
import { TranslateModule, TranslateService } from '@ngx-translate/core';
import { MiddlewareService } from '../../../core/services/middleware.service';
import { apiURL } from '../../../../assets/data/api-url';
import { ApiResponse } from '../../../core/enums/api-response.enum';
import { NgClass } from '@angular/common';
import { NgbActiveModal } from '@ng-bootstrap/ng-bootstrap';
import { VisaTypeId } from '../../../core/enums/visa-type-id.enum';
import { Router } from '@angular/router';

@Component({
  selector: 'app-entry-types',
  standalone: true,
  imports: [TranslateModule, NgClass],
  templateUrl: './entry-types.component.html',
  styleUrl: './entry-types.component.scss'
})
export class EntryTypesComponent {
  @Input() showCloseBtn: boolean = false;
  visaEntryTypeDetails: any;
  currentEntryType = 'single';

  constructor(
    private _middlewareService: MiddlewareService,
    private translateService: TranslateService,
    public activeModal: NgbActiveModal,
    protected router: Router
  ) {
    this.getVisaEntryTypeDetails(this.currentEntryType);
    this.translateService.onLangChange.subscribe(() => {
      this.getVisaEntryTypeDetails(this.currentEntryType);
    });
  }

  getVisaEntryTypeDetails(entryType: string) {
    this.currentEntryType = entryType;
    this._middlewareService
      .callGetMiddleware(`${apiURL.getVisaInstruction}?entry=${this.currentEntryType}&lang=${this.translateService.currentLang}`)
      .subscribe(
        (response) => {

          if (response?.code === ApiResponse.OK) {
            const visaTypes = response?.result?.data ?? [];
            const IMAGE_BASE = '../../../assets/images/dashboard/';
            const DEFAULT_IMAGE = {
              single: 'default.png',
              multiple: 'default.png',
            };
            const IMAGE_MAP: Record<number, { single: string; multiple: string }> = {
              [VisaTypeId.GOVERNMENT_VISA]: { single: 'government-1.png', multiple: 'government-1.png' },
              [VisaTypeId.BUSINESS_VISA]: { single: 'business-1.png', multiple: 'business-2.png' },
              [VisaTypeId.FAMILY_VISIT_VISA]: { single: 'family-1.png', multiple: 'family-2.png' },
              [VisaTypeId.TOURIST_E_VISA]: { single: 'tourist-1.png', multiple: 'tourist-2.png' },

              [VisaTypeId.GOVERNMENT_WORK_VISA]: { single: 'government-1.png', multiple: 'government-1.png' },
              [VisaTypeId.PRIVATE_SECTOR_WORK_VISA]: { single: 'private.png', multiple: 'private.png' },
              // [VisaTypeId.DOMESTIC_WORKER_VISA]: { single: 'domestic-worker-1.png', multiple: 'domestic-worker-2.png' },
              [VisaTypeId.BUSINESS_ENTRY_VISA]: { single: 'business-1.png', multiple: 'business-2.png' },
              [VisaTypeId.FAMILY_DEPENDENTS_VISA]: { single: 'dependent.png', multiple: 'dependent.png' },
              [VisaTypeId.STUDENT_VISA]: { single: 'student.png', multiple: 'student.png' },
              [VisaTypeId.MEDICAL_TREATMENT_VISA]: { single: 'emergency.png', multiple: 'emergency.png' },
              // [VisaTypeId.EMBASSY_VISIT_VISA]: { single: 'embassy-visit-1.png', multiple: 'embassy-visit-2.png' },
              // [VisaTypeId.PASSING_VISA]: { single: 'passing-1.png', multiple: 'passing-2.png' },
              // [VisaTypeId.DEPARTURE_VISA]: { single: 'departure-1.png', multiple: 'departure-2.png' },
              // [VisaTypeId.MULTIPLE_ENTRY_VISA]: { single: 'multi-entry-1.png', multiple: 'multi-entry-2.png' },
              [VisaTypeId.TRANSPORT_DRIVERS_VISA]: { single: 'drivers.png', multiple: 'drivers.png' },
              [VisaTypeId.GOVERNMENT_CONTRCT_WORK_VISA]: { single: 'government-1.png', multiple: 'government-1.png' },
              [VisaTypeId.MULTIPLE_TRIP_BACK_FOR_DRIVER]: { single: 'drivers.png', multiple: 'drivers.png' },
              // [VisaTypeId.RETURN_VISA]: { single: 'return-1.png', multiple: 'return-2.png' },
              // [VisaTypeId.SPECIAL_VISA]: { single: 'special-1.png', multiple: 'special-2.png' },
              [VisaTypeId.EMERGENCY_VISA]: { single: 'emergency.png', multiple: 'emergency.png' },
              // [VisaTypeId.SPORTS_CULTURE_SOCIETY]: { single: 'sports-culture-1.png', multiple: 'sports-culture-2.png' },
            };

            const entryType: 'single' | 'multiple' =
              this.currentEntryType === 'single' ? 'single' : 'multiple';
            this.visaEntryTypeDetails = visaTypes.map((visaType: any) => {
              const matched = IMAGE_MAP[visaType.visaTypeId];
              const fileName = matched ? matched[entryType] : DEFAULT_IMAGE[entryType];
              return {
                ...visaType,
                imagePath: `${IMAGE_BASE}${fileName}`,
              };
            });
          }
        });
  }

}
